import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import axiosInstance from "../../utils/axios";

export const addTeamLead = createAsyncThunk(
  "users/addTeamLead",
  async ({ newTeamLead, onSuccess }, thunkAPI) => {
    try {
      const response = await axiosInstance.post("/Auth/create-user", {
        Email: newTeamLead.Email,
        Password: newTeamLead.Password,
        first_name: newTeamLead.first_name,
        last_name: newTeamLead.last_name,
        Role: newTeamLead.Role,
        profile_pic: "path/to/img.jpg",
      });
      if (response.status === 201) {
        toast.success(response?.data?.details || "add data");
        onSuccess();
        return response.data.details;
      } else {
        const errorMessage = response.data.details;
        return thunkAPI.rejectWithValue(errorMessage);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.details ||
        error.message ||
        "Something went wrong";
      toast.error(errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

export const getAssignedAgents = createAsyncThunk(
  "team_lead/getAssignedAgents",
  async (thunkAPI) => {
    try {
      const response = await axiosInstance.get("/Auth/get-agents");
      console.log("response:/// of teamlead dataaaaa ", response);
      if (response.status === 200) {
        console.log(
          "response.data.details.agents: ",
          response.data.details.agents
        );
        return response.data.details.agents;
      } else {
        const errorMessage = response.data.details;
        return thunkAPI.rejectWithValue(errorMessage);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.details ||
        error.message ||
        "Something went wrong";
      // toast.error(errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

export const assignAgents = createAsyncThunk(
  "team_lead/assignAgents",
  async ({ agent_id, teamLead_ID }, thunkAPI) => {
    try {
      const response = await axiosInstance.post("/Auth/reassign-agent", {
        agent_id: agent_id,
        new_team_lead_id: teamLead_ID,
      });
      console.log("response: ", response);
      if (response.status === 200 || response.status === 201) {
        toast.success("Agent assigned successfully");
        return response.data.details;
      } else {
        const errorMessage = response.data.details;
        return thunkAPI.rejectWithValue(errorMessage);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.details ||
        error.message ||
        "Something went wrong";
      toast.error(errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

export const unassignAgent = createAsyncThunk(
  "team_lead/unassignAgent",
  async ({ agent_id }, thunkAPI) => {
    try {
      const response = await axiosInstance.post("/Auth/unassign-agent", {
        agent_id: agent_id,
      });
      console.log("response: ", response);
      if (response.status === 200 || response.status === 201) {
        toast.success("Agent unassigned successfully");
        return response.data.details;
      } else {
        const errorMessage = response.data.details;
        return thunkAPI.rejectWithValue(errorMessage);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.details ||
        error.message ||
        "Something went wrong";
      toast.error(errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

export const assignBots = createAsyncThunk(
  "team_lead/assignBots",
  async ({ worker_id, user_id }, thunkAPI) => {
    try {
      const response = await axiosInstance.post("/Workers/assign-worker", {
        worker_id: worker_id,
        user_id: user_id,
      });
      console.log("response: ", response);
      if (response.status === 200 || response.status === 201) {
        toast.success("Chatbot assigned successfully");
        return response.data.details;
      } else {
        const errorMessage = response.data.details;
        return thunkAPI.rejectWithValue(errorMessage);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.details ||
        error.message ||
        "Something went wrong";
      toast.error(errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

export const getTeamLead = createAsyncThunk(
  "team_lead/getTeamLead",
  async (teamLeadId, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `/Auth/get-team-lead/${teamLeadId}`
      );
      if (response.status === 200) {
        console.log("response.data.details: ", response.data.details);
        return response.data.details;
      } else {
        const errorMessage = response.data.details;
        return thunkAPI.rejectWithValue(errorMessage);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.details ||
        error.message ||
        "Something went wrong";
      toast.error(errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);
